import React from "react";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Episodes from "@/components/Episodes";
import About from "@/components/About";
import Subscribe from "@/components/Subscribe";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Episodes />
      <About />
      <Subscribe />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
